import { Component, input, output } from '@angular/core';
import { GoalInterface } from '@vendasta/ai-assistants/lib/_internal/interfaces/goal.interface';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { AiAssistantI18nModule } from '../../../assets/i18n/ai-assistant-i18n.module';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'ai-goals-list',
  imports: [CommonModule, MatCardModule, MatListModule, AiAssistantI18nModule, MatIconModule, MatButtonModule],
  templateUrl: './goals-list.component.html',
  styleUrls: ['./goals-list.component.scss', '../ai-assistant-shared.scss'],
})
export class GoalsListComponent {
  readonly goals = input.required<GoalInterface[]>();
  readonly goalClicked = output<string>();
  readonly goalRemoved = output<string>();
}
